import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { dotsVerticalWhiteIcon, infoIcon } from "../../../assets/icons";
import { MOUSE_EVENTS, DATA_TYPES } from "../../../constants";

const { MOUSE_DOWN } = MOUSE_EVENTS;
const { OBJECT } = DATA_TYPES;
const INFO = "info";
const ERROR = "error";

const PopOver = ({
  options,
  classes,
  headerClasses,
  data,
  icon,
  type = INFO,
}) => {
  const ref = useRef(null);
  const [shouldShowPopOver, setShouldShowPopOver] = useState(false);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (shouldShowPopOver && ref.current && !ref.current.contains(e.target))
        setShouldShowPopOver(false);
    };
    document.addEventListener(MOUSE_DOWN, checkIfClickedOutside);
    return () =>
      document.removeEventListener(MOUSE_DOWN, checkIfClickedOutside);
  }, [shouldShowPopOver]);

  return (
    <div className={`${headerClasses} relative`} ref={ref}>
      <button
        className="w-7 h-7 rounded-full grid place-items-center hover:bg-gray-700/50"
        onClick={() => setShouldShowPopOver(!shouldShowPopOver)}
      >
        {icon === INFO ? (
          <img
            src={infoIcon}
            className={classNames("w-4 h-4 rounded-xl", {
              "bg-red-600": type === ERROR,
              "bg-blue-600": type === INFO,
            })}
            alt="info-icon"
          />
        ) : (
          <img
            src={dotsVerticalWhiteIcon}
            className="w-5"
            alt="dots-vertical-white-icon"
          />
        )}
      </button>
      {shouldShowPopOver && (
        <div
          className={classNames(
            "absolute w-56 border border-gray-600 bg-gray-900 z-10 rounded-lg overflow-hidden cursor-pointer",
            { "right-0 top-full": !classes },
            classes
          )}
        >
          <ul>
            {typeof options === OBJECT ? (
              options.map((option) => (
                <li
                  key={option.name}
                  className={classNames(option.classes, {
                    hidden: option.name === "Duplicate",
                  })}
                >
                  <div
                    className="flex items-center text-gray-50 py-2 px-5 hover:bg-gray-800/25"
                    onClick={() => {
                      option.handleOnClick && option.handleOnClick(data);
                      setShouldShowPopOver(false);
                    }}
                  >
                    {option.icon && (
                      <div className="icon mr-3 flex-shrink-0">
                        <img src={option.icon} className="w-5" alt="icon" />
                      </div>
                    )}
                    <span className="text-sm whitespace-pre">
                      {option.name}
                    </span>
                  </div>
                </li>
              ))
            ) : (
              <div className="flex items-center text-gray-50 py-2 px-5 rounded z-10">
                <span className="text-sm whitespace-pre-wrap">{options}</span>
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
export default PopOver;
